export default {
  cms: {
    body: [],
    icon: 'more',
    type: 'cms',
    label: {
      en: 'New Tab'
    }
  },
  'track-and-trace': {
    icon: 'track-and-trace',
    type: 'track-and-trace',
    logo: './static/images/theme-files/square-logo.png',
    label: {},
    journey: []
  },
  'custom-html': {
    icon: 'mdi-language-html5',
    type: 'custom-html',
    label: {
      en: 'Custom HTML'
    },
    html: '',
    _htmlBlocks: {},
    _blocksMeta: {}
  }
}
